import { render, staticRenderFns } from "./NoActivePage.vue?vue&type=template&id=0fa2fe4c&scoped=true"
import script from "./NoActivePage.vue?vue&type=script&lang=js"
export * from "./NoActivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2fe4c",
  null
  
)

export default component.exports